import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";
import { CsvExportButton } from "@shared/components";
import { useNavigate } from "react-router";
import { Box, Chip, Typography } from "@mui/material";
import { useAgreementProductsList } from "./controller";
import { useAgreementProductsListColumns } from "./columns";

export const AgreementProductList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  } = useAgreementProductsList();

  const navigate = useNavigate();

  const columns = useAgreementProductsListColumns(refetch, translate, (row) =>
    navigate(`/agreement-products/edit/${row.id}`, { state: { product: row } })
  );

  return (
    <>
      <List
        title="Produtos dos Agreements"
        headerButtons={
          <>
            <CsvExportButton
              data={dataToExport}
              filename="produtos-agreements.csv"
              isDisabled={loading || !rows}
            />

            <CreateButton onClick={() => navigate("/agreement-products/create")} />
          </>
        }
      >
        <DataGrid
          {...tableProps}
          rows={rows}
          loading={loading}
          columns={columns}
          checkboxSelection
          rowSelectionModel={selectedRows}
          onRowSelectionModelChange={(selectionModel) =>
            setSelectedRows(selectionModel as number[])
          }
        />
      </List>
    </>
  );
});
